import { Box, Button, styled, Typography, Avatar } from "@mui/material";
import React from "react";
import ProfilePicture from "../media/cv_medium.jpg";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import { TypeAnimation } from "react-type-animation";

const Hero = () => {
  const [showIcons, setShowIcons] = React.useState(false);

  const iconsAnimation = useSpring({
    opacity: showIcons ? 1 : 0,
    transform: showIcons ? "translateY(0)" : "translateY(20px)",
    config: { duration: 1000 },
  });

  React.useEffect(() => {
    // Set showIcons to true after a delay (e.g., 1 second)
    const timeoutId = setTimeout(() => {
      setShowIcons(true);
    }, 7000);

    // Clean up the timeout on component unmount
    return () => clearTimeout(timeoutId);
  }, []);

  // TYPING ANIMATION //

  return (
    <Box
      sx={{
        px: 2,
        py: 8,
        maxWidth: "1200px",
        height: "90vh",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",

        "@media (max-width: 600px)": {
          justifyContent: "start",
          height: "80vh",
        },
      }}
      id="home"
    >
      <div className="polygon left"></div>
      <div className="polygon topRight"></div>
      <div className="polygon bottomRight"></div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Customize the shadow
          borderRadius: "50%", // Make the box round
          width: 250,
          height: 250,
          mx: "auto",
          mt: 2,
        }}
      >
        <Avatar
          alt="Avatar"
          src={ProfilePicture}
          sx={{ width: 250, height: 250, margin: "auto" }}
        />
      </Box>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "24px",
          marginBottom: "0px",
        }}
      >
        <TypeAnimation
          sequence={[
            `Hej, mitt namn är Emelie,`,
            800,
            `Hej, mitt namn är Emelie,\nFullstackutvecklare i Node.js och .NET.`,
            800,
            `Hej, mitt namn är Emelie,\nFullstackutvecklare i Node.js och .NET.\nVälkommen till min portfolio!`, // Types 'One'
          ]}
          wrapper="span"
          cursor={true}
          repeat={0}
          speed={50}
          style={{
            display: "inline-block",
            whiteSpace: "pre-line",
            color: "white",
            textAlign: "center",
            fontFamily: "'Arvo', serif",
            fontSize: "18px",
            lineHeight: "1.8",
          }}
        />
        {/*           <Typography
            className="typing"
            sx={{
              color: "white",
              textAlign: "center",
              mb: 2,
              fontFamily: "'Arvo', serif;",
              fontSize: "18px",
              mt: 4,
              // textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            }}
            variant="h3"
          >
            Hej, mitt namn är Emelie
          </Typography>
          <Typography
            className="typing"
            sx={{
              color: "white",
              textAlign: "center",
              mb: 2,
              fontFamily: "'Arvo', serif;",
              fontSize: "18px",
              my: 2,
              // textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            }}
            variant="h3"
          >
            Jag bygger och designar för webben
          </Typography>
          <Typography
            className="typing"
            sx={{
              color: "white",
              textAlign: "center",

              fontFamily: "'Arvo', serif;",
              fontSize: "18px",
              my: 2,
              // textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            }}
            variant="h3"
          >
            Välkommen till min portfolio!
          </Typography> */}
      </div>
      <animated.div style={iconsAnimation}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            mt: 6,
            /*           "@media (max-width: 600px)": {
            mt: 2,
          }, */
          }}
        >
          <a
            href="https://www.linkedin.com/in/emelie-k%C3%B6hler-76773b171/"
            target="_blank"
            rel="noopener"
          >
            <LinkedInIcon
              sx={{ fontSize: "40px", color: "#C68084", cursor: "pointer" }}
            />
          </a>

          <a href="https://github.com/Kwixie" target="_blank" rel="noopener">
            <GitHubIcon
              sx={{ fontSize: "40px", color: "#C68084", cursor: "pointer" }}
            />
          </a>
        </Box>
      </animated.div>
    </Box>
  );
};

export default Hero;
